import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const LockOpenIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M18 8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h9V6a3 3 0 0 0-3-3a3 3 0 0 0-3 3H7a5 5 0 0 1 5-5a5 5 0 0 1 5 5v2h1m-6 9a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2z" />
  </SvgIcon>
);
LockOpenIcon.displayName = 'LockOpenIcon';
LockOpenIcon.muiName = 'SvgIcon';

export default LockOpenIcon;
